// extracted by mini-css-extract-plugin
export default {"addBudgetForm":"AddBudget_addBudgetForm__OF6ZQ"};